<template>
  <div style="background-color: #f5f5f5; overflow: hidden; margin-top: 0.7rem">
    <div class="feedback comBox">
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="100px" :rules="rules" class="demo-ruleForm"
        :size="formSize" status-icon label-position="left">
        <el-form-item label="问题描述" prop="remarks">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" :maxlength="500" show-word-limit
            v-model="ruleForm.remarks" placeholder="请输入问题描述" />
        </el-form-item>
        <el-form-item label="问题证明" prop="filePath">
          <el-input type="hidden" v-model="ruleForm.filePath"></el-input>
          <el-upload v-if="fileList.length == 0" class="upload-demo" drag :action="upload_action" :on-success="onSuccess"
            :on-remove="handleRemove" ref="upload" :file-list="fileList" :show-file-list="false" :limit="1">
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
              <div style="font-size: 0.14rem; color: #333333">
                点击或拖拽文件到此处上传
              </div>
              <div style="font-size: 0.12rem; color: #86909c">上传相关图片</div>
            </div>
          </el-upload>
          <div v-if="fileList.length" style="
              background: #ccc;
              text-align: center;
              width: 150px;
              height: 150px;
            ">
            <el-image style="width: 150px; height: 150px" fit="fit" :src="fileList[0].url"
              :preview-src-list="[fileList[0].url]">
            </el-image>
            <div class="img-text">
              {{
                fileList[0].name1.match(regex)[1] +
                "" +
                fileList[0].name1.match(regex)[2]
              }}
            </div>
            <el-image :src="url" @click="handleRemove()" class="img-Off" />
          </div>
        </el-form-item>
      </el-form>
      <div class="dataBtn" @click="submit">提交</div>
    </div>
    <div style="height: 1.34rem"></div>
  </div>
</template>

<script lang="ts" setup>
import { UploadFilled } from "@element-plus/icons-vue";
import { reactive, ref } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
const upload_action = ref(serverBaseUrl + "/file/upload");
import url from "@/assets/module_share_open.png";
const userList = JSON.parse(localStorage.getItem("userList"));
document.title = "标识山西-意见反馈";
import type { FormInstance, FormRules } from "element-plus";
const ruleForm = ref({
  remarks: "",
  filePath: "",
  createUser: "",
  avatar: ""
});
const ruleFormRef = ref()
const fileList = ref([]);
const regex = /(.+)_.*(\..+)/;
const rules = reactive<any>({
  remarks: [{ required: true, message: "请输入问题描述", trigger: "change" }],
  filePath: [{ required: true, message: "请上传问题证明", trigger: "change" }],
});
const submit = () => {
  ruleForm.value.createUser = userList.memberId;
  ruleForm.value.avatar = userList.avatar;
  ruleFormRef.value.validate((valid: boolean) => {
    if (valid) {
      Axios(
        "post",
        "/system/advice",
        ruleForm.value,
        false,
        function (res) {
          console.log(res);
          if (res.data.code == 200) {
            ElMessage({
              message: '提交成功！',
              type: 'success',
            })
            ruleForm.value = {
              remarks: "",
              filePath: "",
              createUser: "",
              avatar: ""
            };
            fileList.value = [];
            ruleFormRef.value.resetFields();
          } else {
            ElMessage({
              message: res.data.msg,
              type: 'error',
            })
          }

        }
      );
    } else {
      ElMessage.warning("请填写完整信息");
    }
  });
}
// 上传成功
const onSuccess = (res: any, file: any, fileList1: any) => {
  console.log(res, file, fileList1);
  fileList.value.push({
    url: res.data.url,
    name: res.data.name,
    name1: res.data.name.split("?")[0],
  });
  ruleForm.value.filePath = res.data.url;
};
// // 删除图片
const handleRemove = (file, fileList1, type) => {
  fileList.value = [];
  ruleForm.value.filePath = null;
};
</script>

<style scoped>
@import url(/src/assets/css/com.css);

.feedback {
  margin: 0 auto;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0.3rem auto 0.3rem;
  padding: 0.8rem;
}

.dataBtn {
  width: 2.68rem;
  padding: 0.12rem 1.06rem;
  background: #ff6000;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  font-size: 0.14rem;
  color: #fff;
}

/deep/.el-upload-dragger {
  background: #f5f5f5;
}

.img-text {
  position: absolute;
  /* left:100px; */
  bottom: 0px;
  text-align: center;
  font-size: 10px;
  width: 150px;
  display: none;
  background: rgba(0, 0, 0, 0.2);

  /* left: 0px; */
}

.img-Off {
  position: absolute;
  left: 130px;
  top: -15px;
  width: 40px;
  height: 40px;
  z-index: 5555;
}
</style>
